//////////////////////////////////////////////////////////////////////
// Configurations related to search                                 //
// Note: some search experience is also on defaultMapsConfig        //
// and defaultListingConfig.js is responsible public data filtering //
//////////////////////////////////////////////////////////////////////

// NOTE: if you want to change the structure of the data,
// you should also check src/util/configHelpers.js
// some validation is added there.

// Main search used in Topbar.
// This can be either 'keywords' or 'location'.
// Note: The mainSearch comes from the listing-search asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
export const mainSearch = {
  searchType: 'keywords',
};

/**
 * Configuration for default filters.
 * These are custom configs for each filter.
 * Common properties: key, schemaType, and label.
 * Note: the order of default filters is defined in util/configHelpers.js
 * To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
 */

export const listingTypeFilter = {
  enabled: false,
  schemaType: 'listingType',
  // schemaType, key, and other built-in config values are completely filled in configHelper.js
};

export const categoryFilter = {
  enabled: false,
  schemaType: 'category',
  // schemaType, key, and other built-in config values are completely filled in configHelper.js
};

export const dateRangeFilter = {
  schemaType: 'dates',
  // Should the entire date range be available, or just part of it
  // Note: Since we don't enforce location search for dates filtering,
  //       we don't use API's 'time-full' in actual queries. It would require time zone info.
  availability: 'time-full', // time-partial
  // Options: day/night. This affects counting and whether single day picking is possible.
  dateRangeMode: 'day',
};

/**
 * Note: the order of default filters is defined in util/configHelpers.js
 * To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
 */
export const priceFilter = {
  schemaType: 'price',
  // Note: unlike most prices this is not handled in subunits
  min: 0,
  max: 2000,
  step: 5,
};
export const keywordsFilter = {
  key: 'keywords',
  schemaType: 'keywords',
};

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: true,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Marketplace API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Sort key that maps to "no API sort param" -- the duck reads this and
  // omits `sort` from the API call when the user picks it. Renamed from
  // 'relevance' to 'recommended' so the user-facing label is "Recommended"
  // and it's surfaced regardless of search type (the previous Sharetribe-
  // standard keyword-search gate hid it on location-based marketplaces).
  relevanceKey: 'recommended',

  // The original relevanceFilter wired this option to the keywords
  // filter; we no longer rely on that linkage since "Recommended" is
  // always meaningful (it's just "Merrily's default ordering").
  relevanceFilter: 'keywords',

  // Keyword filter is sorting the results by relevance.
  // If keyword filter is active, one might want to disable other sorting
  // options by adding 'keywords' to this list.
  conflictingFilters: [],

  // Trimmed sort options per user request (2026-04-28). Old options
  // (Newest, Oldest, Relevance) dropped -- users don't care about
  // listing date for party kits. Added Top Rated; this requires
  // listings to carry a meta_rating metadata field (set by aggregating
  // reviews) for the sort to actually have an effect. See TODO.md.
  options: [
    { key: 'recommended', labelTranslationKey: 'SortBy.recommended' },
    // 'Top Rated' (-meta_rating) hidden until review aggregation writes
    // meta_rating — offering it pre-launch shuffled results for no
    // explicable reason (audit P2). Re-add with the reviews project.
    // { key: '-meta_rating', labelTranslationKey: 'SortBy.topRated' },
    // Sharetribe returns `price` descending and `-price` ascending — verified
    // live 2026-07-01 (UI/UX audit P0-4): these labels were mapped backwards.
    { key: '-price', labelTranslationKey: 'SortBy.priceLowToHigh' },
    { key: 'price', labelTranslationKey: 'SortBy.priceHighToLow' },
  ],
};
